/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function IntermediateTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    IntermediateTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {
    };
    const getData = () => {
        this.loadingIndicator.show = true;
        IntermediateTemplatesService.getIntermediateTemplate($routeParams.id).then((intermediateTemplate: JS5Object) => {
            IntermediateTemplatesService.originalEditData = _.cloneDeep(intermediateTemplate);
            this.editData = intermediateTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewIntermediateTemplate();
        }
        else {
            updateIntermediateTemplate();
        }
    };

    const updateIntermediateTemplate = () => {
        IntermediateTemplatesService.updateIntermediateTemplate(this.editData).then((intermediateTemplate: JS5Object) => {
            IntermediateTemplatesService.originalEditData = _.cloneDeep(intermediateTemplate);
            this.editData = intermediateTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewIntermediateTemplate = () => {
        IntermediateTemplatesService.createIntermediateTemplate(this.editData).then((intermediateTemplate: JS5Object) => {
            $route.updateParams({id: intermediateTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.size(_.get(this.editData, 'name')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(IntermediateTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'IntermediateTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = IntermediateTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Intermediate Template',
                        location: '/system/templates/search',
                        params: {tab: 'IntermediateTemplates'}
                    });
                }
                getData();
            } else {
                IntermediateTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Intermediate Template',
                    location: '/system/templates/search',
                    params: {tab: 'IntermediateTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        IntermediateTemplatesService.originalEditData = null;
        IntermediateTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            IntermediateTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = IntermediateTemplatesService;
        });
    };
}


angular.module('prism-ui.intermediateTemplate').component('intermediateTemplatesEditView', {
    templateUrl: 'system/templates/intermediateTemplate/editor/intermediate-template-edit-template.html',
    controller: IntermediateTemplatesEditViewController,
    bindings: {
    }
});
